module.exports = __webpack_public_path__ + "media/images/home/right_demo-31cebd7c82f223bd82052977253f2048.png";